// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from "react";
import { useSigningRequest, } from "@/components/signing/SigningProvider";
/** The signing request a route answered instead of running the action, if it did. */
export var signingRequestOf = function (reply) { var _a, _b; return (_b = (_a = reply === null || reply === void 0 ? void 0 : reply.signing_request) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null; };
/** The signing panel, where a `SigningProvider` hosts one. */
export var useOptionalSigningRequest = function () {
    try {
        return useSigningRequest();
    }
    catch (_a) {
        return null;
    }
};
/**
 * For the routes of protected actions: when the answer is a signing request,
 * opens its panel, which says the action waits for signatures, with the
 * signing dialog when the viewer can sign.
 * Returns whether it did, so the caller skips what it does once the action ran;
 * without a `SigningProvider` there is no panel, and it doesn't.
 */
export var useSignedAction = function () {
    var signing = useOptionalSigningRequest();
    return useCallback(function (reply, options) {
        var requestId = signingRequestOf(reply);
        if (!requestId || !signing)
            return false;
        // The dialog opens at once when the viewer can sign it.
        signing.open(requestId, __assign({ sign: true }, options));
        return true;
    }, [signing]);
};
